module.exports = __webpack_public_path__ + "img/img-3-15.b942dc8d.webp";